import { Select } from "@chakra-ui/react";
import { Tooltip } from "../../Tooltip";
import { InputProps } from "../Input";
import { Button, InputContainer, Text, Container } from "./styles";
import { MdArrowDropDown } from "react-icons/md"
interface Props extends InputProps {
  icon?: any;
  buttonText?: string;
  tooltipButtonText?: string;
  buttonfunction?: any;
  label?: string;
  disabled?: boolean;
  buttonDisabled?: boolean;
  width?: string;
  buttonFunction?: () => void;
  color?: any;
}

export function SelectButton({
  icon,
  buttonText,
  tooltipButtonText,
  label,
  buttonfunction,
  errors,
  disabled = false,
  buttonDisabled = false,
  buttonFunction,
  width,
  color,
  register,
  labelColor = "var(--gray-400)",
  children,
  ...rest
}: Props) {
  return (
    <Container>
      <Text color={labelColor} fontSize="12px">
        {label}
      </Text>
      <InputContainer 
        disabled={disabled} 
        className="inputContainer" 
        borderColor={errors ? "var(--red-700)" : "#C3CAD7"}
        bgColor="#EDF1F7"
        width={width}
      >
        <Select
          color={color}
          p="0"
          fontSize="16px"
          disabled={disabled}
          border="none"
          w="100%"
          icon={disabled ? "none" : <MdArrowDropDown />}
          _focus={{}}
          {...register}
          _disabled={{
            border: "none",
            p: "0"
          }}
          _hover={{
            cursor: "pointer"
          }}
        >
          {children}
        </Select>
        <Button 
          className="button"
          disabled={buttonDisabled}
          onClick={buttonFunction}
        >
          {icon && !buttonText && !disabled && (
            <Tooltip text={tooltipButtonText}>
              {icon}
            </Tooltip>
          )}
          {buttonText && !icon && !disabled && (
            <Tooltip text={tooltipButtonText}>
              {buttonText}
            </Tooltip>
          )}
        </Button>
      </InputContainer>
      {errors && (
        <Text color="var(--red-600)" fontSize=".8rem">
          {errors?.message}
        </Text>
      )}
    </Container>
  )
}